<template>
  <div>
    <v-card class="standby_lnfo">
      <v-card-text>
        <p>
          営業時間のご案内<br />
          {{ businessDayTxt }}<br />
          {{ businessHoursStart }}:00 - {{ businessHoursEnd }}:00
        </p>
        現在：{{ hour }}：{{ minute }}
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import store from "../store";
import router from "../vue-router/index";
import Export from "../export";
export default {
  name: "Stand-by",
  data() {
    return {
      getOperationTimerId: null,
    };
  },
  async mounted() {
    if (this.driverMode == null) {
      router.push("/");
    }
    if (
      Number(this.hour) >= this.businessHoursStart &&
      Number(this.hour) < this.businessHoursEnd &&
      this.holiday.indexOf(this.dayOfWeekStr) == -1
    ) {
      router.push("/client");
    } else {
      this.getOperationTimerId = setInterval(this.getOperation, 30000);
      /*var txt =
        "Stand-by page started with bus stop id " + this.currentBusStopId + ".";
      await Export.postMail(txt, store.state.mail);*/
    }
  },
  computed: {
    dayOfWeek: {
      get() {
        return store.state.dayOfWeek;
      },
      set(value) {
        store.state.dayOfWeek = value;
      },
    },
    dayOfWeekStr: {
      get() {
        return store.state.dayOfWeekStr;
      },
      set(value) {
        store.state.dayOfWeekStr = value;
      },
    },
    hour: {
      get() {
        return store.state.hour;
      },
      set(value) {
        store.state.hour = value;
      },
    },
    minute: {
      get() {
        return store.state.minute;
      },
      set(value) {
        store.state.minute = value;
      },
    },
    businessHoursStart: {
      get() {
        return store.state.businessHoursStart;
      },
      set(value) {
        store.state.businessHoursStart = value;
      },
    },
    businessHoursEnd: {
      get() {
        return store.state.businessHoursEnd;
      },
      set(value) {
        store.state.businessHoursEnd = value;
      },
    },
    holiday: {
      get() {
        return store.state.holiday;
      },
      set(value) {
        store.state.holiday = value;
      },
    },
    businessDayTxt: {
      get() {
        return store.state.businessDayTxt;
      },
      set(value) {
        store.state.businessDayTxt = value;
      },
    },
    operationCommand: {
      get() {
        return store.state.operationCommand;
      },
      set(value) {
        store.state.operationCommand = value;
      },
    },
    driverMode: {
      get() {
        return store.state.driverMode;
      },
      set(value) {
        store.state.driverMode = value;
      },
    },
    currentBusStopId: {
      get() {
        return store.state.currentBusStopId;
      },
      set(value) {
        store.state.currentBusStopId = value;
      },
    },
  },
  methods: {
    async getOperation() {
      var getOperation = await Export.getOperation();
      this.operationCommand = getOperation.data[0];
    },
    restart() {
      location.reload();
    },
  },
  watch: {
    minute() {
      if (
        Number(this.hour) >= this.businessHoursStart &&
        Number(this.hour) < this.businessHoursEnd &&
        this.holiday.indexOf(this.dayOfWeekStr) == -1
      ) {
        clearInterval(this.getOperationTimerId);
        router.push("/client");
      }
    },
    operationCommand() {
      if (this.operationCommand.restart == "true") {
        var clientIds = JSON.parse(this.operationCommand.clientIds);
        if (clientIds.indexOf(String(this.currentBusStopId)) != -1) {
          this.restart();
        }
        if (this.currentBusStopId == null) {
          if (clientIds.indexOf("null") != -1) {
            this.restart();
          }
        }
      }
    },
  },
};
</script>
<style>
.standby_lnfo {
  text-align: center;
  margin-top: 20vh;
}
.standby_lnfo p {
  font-size: 3rem;
  line-height: 4rem;
  padding: 10vh 0;
}
</style>
